<template>
<div>

    <v-row v-for="row in my_ui.rows">
        
        <v-col :cols="is_single_row(row)?12:6" >
            <any-field-modeler
                v-model="my_payload[row.field_1.field]"
                :field="row.field_1"
                @input="emit_payload"
                :readonly="readonly"
            >
            </any-field-modeler>
        </v-col>
        <v-col cols="6" v-if="!is_single_row(row)">
            <any-field-modeler
                v-model="my_payload[row.field_2.field]"
                :field="row.field_2"
                @input="emit_payload"
                :readonly="readonly"
            >
            </any-field-modeler>
        </v-col>

    </v-row>
</div>
</template>

<script>

import AnyFieldModeler from '@/modules/entities/infra/UIComponents/AnyFieldModeler.vue'

export default {
    name: "InstanceEditorV1",
    components: {
        AnyFieldModeler
    },
    data() {
    return {
        my_payload: {},
    }
    },
    props: {
    value: {
        type: Object,
        required: true,
    },
    my_ui: {
        type: Object,
        required: true,
        default: {},
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    },
    async mounted() {
    console.log(this.value)
    console.log(this.my_ui)
    this.fill_payload();
    },
    methods: {
        is_single_row(row){
            return row.field_2 === undefined || row.field_2.field === undefined || row.field_2.field === '';
        },
        give_values_to_the_fields(field_nested){
            let value = ''
            for (let i = 0; i < field_nested.length; i++) {
                if (this.value && this.value[field_nested[i]] !== undefined && this.value[field_nested[i]] !== null){
                    if (i === 0) {
                        value = this.value[field_nested[i]];
                    } else {
                        value = value[field_nested[i]];
                    }
                }
            }
            return value
        },
        fill_payload() {
            console.log(this.my_ui.rows)
            let flat_value = {}
            this.my_ui.rows.forEach(row => {
                if (row.field_1 && row.field_1.field){
                    let field_1 = row.field_1.field;
                        //split the field_1.field by '.' to get the nested object
                    let field_1_nested = field_1.split('.');
                    let value1 = this.give_values_to_the_fields(field_1_nested)
                    if(field_1 !== ''){
                        flat_value[field_1] = value1;
                    }
                }
                if (row.field_2 && row.field_2.field){
                    let field_2 = row.field_2.field;
                    
                    let field_2_nested = field_2.split('.');
                    
                    let value2 = this.give_values_to_the_fields(field_2_nested)
                    
                    if(field_2 !== ''){
                        flat_value[field_2] = value2;
                    }
                }

            });
            this.my_payload = {...flat_value}
            console.log(this.my_payload)


        },
        emit_payload() {
            let res = {...this.value};
            this.my_ui.rows.forEach(row => {
                let field_1 = row.field_1.field;
                let field_2 = row.field_2.field;
                //split the field_1.field by '.' to get the nested object
                let field_1_keys = field_1.split('.'); // ['direccion','calle'] ['username']
                let field_2_keys = field_2.split('.');

                let target = res
                for(let i in field_1_keys.length - 1){
                    let key = field_1_keys[i]
                    target = target[key]
                }
                let last_key = field_1_keys[field_1_keys.length - 1]
                target[last_key] = this.my_payload[field_1]

                target = res
                for(let i in field_2_keys.length - 1){
                    let key = field_2_keys[i]
                    target = target[key]
                }
                last_key = field_2_keys[field_2_keys.length - 1]
                target[last_key] = this.my_payload[field_2]
                
            });
            this.$emit('input', res);
        },
        format_type(type) {
            if (type === 'string') {
                return 'text'
            }
            if (type === 'number' || type === 'integer' || type === 'float') {
                return 'number'
            }
        }
    },
    
    
};
</script>

<style scoped>
.nested-section {
    padding-left: 10px;
    /*border-left: 1px solid #ccc; */
    margin-top: 10px;
}
</style>
